import { useCallback, useRef } from 'react';
import { Location, useBlocker, useNavigate } from 'react-router-dom';

type NavigationBlockerProps = {
  when: boolean;
  onBlock: (navigateTo: () => void) => void;
};

export const useNavigationBlocker = ({
  when,
  onBlock,
}: NavigationBlockerProps) => {
  const navigate = useNavigate();
  const blockedNavigationRef = useRef<(() => void) | null>(null);

  const blocker = useBlocker(
    useCallback(
      ({
        currentLocation,
        nextLocation,
      }: {
        currentLocation: Location;
        nextLocation: Location;
      }) => {
        if (when && currentLocation.pathname !== nextLocation.pathname) {
          blockedNavigationRef.current = () => {
            navigate(
              nextLocation.pathname + nextLocation.search + nextLocation.hash,
            );
          };

          // Call the onBlock callback with the navigation function
          onBlock(() => {
            if (blockedNavigationRef.current) {
              blockedNavigationRef.current();
              blockedNavigationRef.current = null;
            }
          });

          return true; // block navigate
        }
        return false; // allow navigate
      },
      [when, onBlock, navigate],
    ),
  );

  return {
    isBlocked: blocker.state === 'blocked',
  };
};
